export enum EOrgstructureUnitType {
  /**
   * Отдел
   */
  UNIT = 'UNIT',
  /**
   * Служба
   */
  SERVICE = 'SERVICE',
  /**
   * Управление
   */
  DIVISION = 'DIVISION',
  /**
   * Департамент
   */
  DEPARTMENT = 'DEPARTMENT',
  /**
   * Руководитель
   */
  DIRECTOR = 'DIRECTOR',
  /**
   * Представитель
   */
  REPRESENTATIVE = 'REPRESENTATIVE',
  /**
   * ПВС
   */
  PVS = 'PVS',
}

export enum EOrgstructureDictObjectType {
  /**
   * Организация
   */
  DICT_ORGANIZATION = 'DICT_ORGANIZATION',
  /**
   * Подразделение
   */
  DICT_UNIT = 'DICT_UNIT',
}
